module.exports = __webpack_public_path__ + "static/media/Spine Surgery-Condition Intake-1@3x.37e5d1bb.png";